module.exports = __webpack_public_path__ + "img/pia21974.0.17df4049.jpg";